var sticky_price = $("#huratips-addtocart-sticky .sticky-price span.pro-sale-price").text();

sticky_price = parseFloat(sticky_price);  
var PriceCurr = $('body').attr('data-cart-curr');

$(document).on("click", ".checkbox-label", function () {

    // Optionally trigger a 'click' event if needed (this is not always required)
   $(this).prev(".variant-checkbox").trigger('click');
   $(this).prev(".variant-checkbox").prop('checked', true);
   $(this).prev(".variant-checkbox").show();
   $(this).hide();
   $(this).next(".check-remove-btn").show();


  var Add_on_price = $(this).prev(".variant-checkbox").attr('data-price');
    Add_on_price = parseFloat(Add_on_price); 
  
    if (!isNaN(Add_on_price)) { 
        sticky_price += Add_on_price; 
        sticky_price = parseFloat(sticky_price.toFixed(2));

        $('.sticky-price .price__sale .price-item--sale').text(PriceCurr + '' + sticky_price);
         
    } 

  

});
$(document).on("click", ".check-remove-btn", function () {

   $(this).prev().prev(".variant-checkbox").trigger('click');
   $(this).prev().prev(".variant-checkbox").prop('checked', false);
   $(this).prev(".variant-checkbox").hide();
   $(this).hide();
  $(this).prev(".checkbox-label").show();


      var Remove_on_price = $(this).prev().prev(".variant-checkbox").attr('data-price');
      Remove_on_price = parseFloat(Remove_on_price); 
  
      if (!isNaN(Remove_on_price)) { 
        sticky_price -= Remove_on_price; 
        sticky_price = parseFloat(sticky_price.toFixed(2)); 
        
       $('.sticky-price .price__sale .price-item--sale').text(PriceCurr + '' + sticky_price);
        
       
      } 


});


// $(document).on('click', '.size-product-ddd label', function() {

//     setTimeout(function() {
  
//        var price = $('.price-item--sale').attr('data-price');
//         $('.sticky-price .price__sale .price-item--sale').text(price);
//         console.log("Selected variant price:", price);
//     }, 500); 
// });




$(document).on("change", ".variant-section select.variant-option", function () {
  var varID = $(this).val();
  $(this).next(".variant-checkbox").val(varID);
});

$(document).on("click", ".add-to-cart.custom-add-button", function () {

  var selectedVariants = [];

  var productId = $(".product-variant-id").val();

  selectedVariants.push(productId);

  
  $(".variant-section .variant-checkbox:checked").each(function () {
    selectedVariants.push($(this).val());
  });
   
  console.log("Selected Variant IDs:", selectedVariants);

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      quantity: 1,
      id: selectedVariants,
    },
    dataType: "json",
    success: function (response) {
      console.log(response)
     window.location.href='/cart';
    },
    error: function (error) {
      console.error("Error adding product to cart:", error);
    },
  });
});
